module.exports = __webpack_public_path__ + "img/3.ff0475db.jpg";